import type { FaireProductEntity } from "../../entity_types/product";

export const p_u9xhj4xhea: FaireProductEntity = {
  token: "p_u9xhj4xhea",
  type: "product",
  name: "brass card holder",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/a6fb0535885a249b653f22272c70006d2b17685f8efe5782b41024c2be4f348e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1d9e7822fe21f9163b967aba5fa1ce350c8fc2125d2246374bd41f4dcc734255.jpeg",
    "https://cdn.faire.com/fastly/39d060517656ee0659a15428eda3f64211875d7156d36ea7257c270c3be9c163.jpeg",
    "https://cdn.faire.com/fastly/a540470aa40b0e301d27d2c84a37b8c3d0bcec9783c0bacf9c2b2c1eb0166a86.jpeg",
  ],
  priceDollars: 8,
  description:
    'Display your Truth for Today cards in style. This satin brass card holder comfortably holds all 31 cards and makes it easy to flip through the cards. Set out on a table, desk, bookshelf, or window sill.\n\nDetails:\n\n- 3.5" x 2.25" x 1.75"\n- satin brass\n- cards not included\n\n',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:11.694Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
